


























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';

import { Organization } from '@/common/Organizations';

import TextField from '@/components/Form/TextField.vue';
import SwitchField from '@/components/Form/SwitchField.vue';

import { required, requiredIf } from 'vuelidate/lib/validators';

@Component({
	name: 'MainTab',
	components: {
		TextField,
		SwitchField,
	},
	validations: {
		fields: {
			org_name: {
				required,
			},
			brokerageId: {
				requiredIf: requiredIf(vm => vm.is_agency),
			},
		},
	},
})
export default class OrgManagement extends Vue {
	@State('organization', { namespace: 'Organizations' }) private organization: Organization;

	private fields: Organization = {
		org_id: '',
		org_name: '',
		is_agency: false,
		brokerageId: '',
		address: {
			address_line_1: '',
			address_line_2: '',
			city: '',
			state: '',
			zipcode: '',
		},
		phone_number: '',
	};

	@Watch('organization')
	private watchOrganization() {
		this.fields = this.organization;
	}

	private created() {
		this.fields = this.organization;
	}
}
